import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { HttpRequestService } from 'src/app/Services/Http/http-request.service';
import { PropertiesService } from 'src/app/Services/Properties/properties.service';
import { SearchService } from 'src/app/Services/search.service';

@Component({
  selector: 'app-career-list',
  templateUrl: './career-list.component.html',
  styleUrls: ['./career-list.component.css']
})
export class CareerListComponent implements OnInit {
  subscription: Subscription;
  @Output() searchItem: EventEmitter<any> = new EventEmitter();
  searchInvoiceAdapter: any;
  constructor(private httpRequestService:HttpRequestService,
    private searchService: SearchService, 
    private router: Router,private property: PropertiesService) {
      this.subscription = searchService.searchRefreshEvt$.subscribe(() => {
        this.getGridData();
      });
     }

  ngOnInit() {
    this.getGridData();
  }

  ngAfterViewInit(): void {
    this.getGridData();
  }

  searchInvoiceColumns: any[] =
  [
    {
      text: 'S.No', width: '5%', sortable: false, menu: false, cellsrenderer: function (row, cell, value) {
        return '<div style="text-align: center; margin-top: 10px;">' + (1 + row) + '</div>';
      }
    },
    { text: 'JobID', datafield: 'JobID', width: '5%', hidden:true },
    { text: 'Region', datafield: 'RegionIDName', width: '15%' },
    { text: 'Category', datafield: 'CategoryIDName', width: '20%' },
    { text: 'Position', datafield: 'Position', width: '20%' },
    { text: 'ValidFrom', datafield: 'ValidFrom', width: '15%',columntype: 'datetimeinput', cellsformat: 'dd/MM/yyyy', filtertype: 'range' },
    { text: 'ValidTo', datafield: 'ValidTo', width: '15%',columntype: 'datetimeinput', cellsformat: 'dd/MM/yyyy', filtertype: 'range' },
    { text: 'Status', datafield: 'Status', width: '10%' },
  ];

  searchInvoiceSource: any =
  {
    datatype: 'json',
    datafields: [
      { name: 'JobID', type: 'int' },
      { name: 'RegionIDName', type: 'string' },
      { name: 'CategoryIDName', type: 'string' },
      { name: 'Position', type: 'string' },
      { name: 'ValidFrom', type: 'date' },
      { name: 'ValidTo', type: 'date' },
      { name: 'Status', type: 'string' },
    ],
    id: 'careerid',
    localdata: ''
  };
  getGridData() {
    this.getData().then((list: any) => {
      this.searchInvoiceSource.localdata = list.result;
      this.searchInvoiceAdapter = new jqx.dataAdapter(this.searchInvoiceSource);
    });

  }
  getData(){
    return new Promise((resolve, reject) => {
      this.httpRequestService.get(this.property.WebAPIipAndPort.concat(this.property.BSSAPI) +"/Job_List/LOV_Job_List_Grid")
        .then((res: any) => {
          console.log('Response', res);
          if (res.status == 200) {
            resolve(res);
          }
        }, (error) => {
          reject(error);
        });
    });
  }

  RowclickInvoiceSearch(event: any): void {
    var args = event.args;
    var selectedRowIndex = args.rowindex;
    this.searchItem.emit();
    args.row.bounddata.timestamp = new Date().getTime();
    console.log(args);
    this.router.navigate(['home/addcareer'], { queryParams: args.row.bounddata });

  }
}
